import { gql } from 'graphql-request'

export const UPDATE_LAST_LOGIN = gql`
  mutation UpdateLastLoginAdmin {
    updateLastLoginAdmin {
      message
    }
  }
`
